export function sortImages(images, allImages) {
  return [
    ...images,
    ...allImages.filter(image => !images.find(img => img.small === image.small)),
  ];
}

export const getDeterministicImage = (id, estabFallbackImages, index = 0) => estabFallbackImages[Math.abs(Number(id) + Number(index)) % estabFallbackImages.length];
